<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="3" lg="3" xxl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Reservas</b>
            <button type="button" class="btn btn-sm btn-outline-main bg-purple color-white" @click="mtdBack">
              <i class="fas fa-home-lg-alt"></i>&nbsp;&nbsp;Inicio
            </button>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Desde" type="date" aria-label="shift_date" size="sm" id="init" v-model="filter.init"
                  @input="applyDateFilter" @change="validateDays" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Hasta" type="date" aria-label="shift_date" id="end" size="sm" v-model="filter.end"
                  @input="applyDateFilter" @change="validateDays" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="9" lg="9" xxl="9">
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-2 mb-2">
            <div class="bg-card-reservado p-4 rounded-lg shadow mb-4">
              <h3 class="text-lg font-semibold mb-2 text-title">Reservado</h3>
              <input type="text" placeholder="Buscar" class="form-control mb-4" />
              <div id="content-reservado" class="px-2">
                <!-- Dragable reservado -->
                <draggable :disabled="isMobile" :group="{ name: 'states' }" @end="onDragReservado" class="list-group"
                  id="reservado">
                  <div v-for="(item, index) in listreservado" :key="index" class="text-dark">
                    <CCard>
                      <CCardHeader>
                        <CRow class="mb-2">
                          <CCol class="col-9">
                            <strong>Encargado:</strong>
                            <span v-for="(barber, index) in item.barber_detail" :key="index">
                              {{
                                barber.barber
                                  ? barber.barber.name +
                                  " " +
                                  barber.barber.last_name
                                  : "No existe Personal"
                              }}{{
                                item.barber_detail.length - 1 == index
                                  ? ""
                                  : ","
                              }}
                            </span>
                          </CCol>
                          <CCol class="col-3 text-right">
                            <CButton v-if="
                              item.payment == 0 ||
                              item.payment == 1 ||
                              (item.sale.voucher &&
                                item.sale.voucher[0] &&
                                item.sale.voucher[0].document_type_id == 3)
                            " class="card-header-action btn-close bg-danger text-white mr-2"
                              @click="mtdEliminar(item)">
                              <i class="fas fa-trash"></i>
                            </CButton>
                          </CCol>
                        </CRow>
                        <CRow class="mb-2">
                          <CCol class="col-12">
                            <strong>Cliente: </strong>{{ item.name_client }}
                          </CCol>
                        </CRow>
                        <CRow class="mb-2">
                          <CCol class="col-12">
                            <b>Fec. y hora:</b> {{ formatDate(item.date) }}
                            {{ formatTime(item.hour) }}
                          </CCol>
                        </CRow>
                        <div class="card-header-actions">
                          <CButton class="card-header-action btn-minimize bg-info text-white mr-2"
                            @click="mtdSelectCardReserva(item.id)" :aria-expanded="isCollapsed == item.id ? 'true' : 'false'
                              " :aria-controls="'collapse-' + item.id">
                            <div v-if="!isMobile">
                              <i v-if="isCollapsed == item.id" class="fas fa-chevron-up"></i>
                              <i v-else class="fas fa-chevron-down"></i>
                            </div>
                          </CButton>
                          <CButton v-if="item.client?.phone != null"
                            class="card-header-action btn-close bg-success text-white mr-2"
                            @click="mtdViewSendWsp(item)">
                            <i class="fab fa-whatsapp"></i>
                          </CButton>
                          <CButton v-if="
                            getPayment(item.payment) == 'Sin Pagar' ||
                            getPayment(item.payment) == 'Parcialmente Pagado'
                          " class="card-header-action btn-close bg-success text-white mr-2"
                            @click="mtdUpdateQuote(item.id, item.state)">
                            <i class="fas fa-edit"></i>
                          </CButton>
                          <CButton class="card-header-action bg-dark text-white" @click="updateItemState(item.id, 2)">
                            <i class="fas fa-hand-point-right"></i>
                          </CButton>
                        </div>
                      </CCardHeader>
                      <CCollapse :show="isCollapsed == item.id || isMobile" :duration="400">
                        <CCardBody>
                          <div>
                            <strong>Servicios:</strong>
                            <ul v-for="(service, index) in item.detail" :key="index">
                              <li>
                                {{ service.name_service }} - S/
                                {{ service.price }} ({{ service.quantity }})
                              </li>
                            </ul>
                          </div>
                          <div v-if="
                            item.detail_product && item.detail_product.length
                          ">
                            <strong>Productos:</strong> <br />
                            <ul v-for="(prod, index) in item.detail_product" :key="index">
                              <li>
                                {{ prod.name }} - S/ {{ prod.price }} - und.
                                {{ prod.quantity }}
                              </li>
                            </ul>
                          </div>
                          <div>
                            <strong>Total:<i> {{ item.total }} </i></strong>
                          </div>
                          <div class="mt-2 d-flex flex-wrap">
                            <button :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdPaymentBooking(item)" :disabled="getPayment(item.payment) == 'Pagado'">
                              {{ getPayment(item.payment) }}
                            </button>
                            <!-- <button v-if="!item.detail_product" :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdAddCourtesy(item.id, product)"
                              :disabled="getPayment(item.payment) == 'Pagado'">
                              Productos
                            </button>
                            <button v-else :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdEditCourtesy(item, product)" :disabled="getPayment(item.payment) == 'Pagado'">
                              Productos
                            </button> -->
                            
                            <CButton v-if="item.advance_payment == '0.00' && $store.getters.get_rol.name == 'ADMINISTRADOR'" 
                            :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdPaymentMethod(item)" :disabled="getPayment(item.payment) == 'Pagado'">
                              Adelanto
                            </CButton>
                            <CButton v-if="getPayment(item.payment) == 'Pagado'" :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-danger btn-sm mr-1 my-1',
                            ]" @click="mtd_ticket(item)">
                              <i class="fas fa-file-pdf"></i>
                            </CButton>
                            <CButton class="btn-sm my-1 mr-1" color="primary" v-c-tooltip.hover="{
                              content: `Servicios anteriores`,
                            }" @click="mtdViewServices(item)">
                              <i class="fas fa-cut"></i>
                            </CButton>
                          </div>
                        </CCardBody>
                      </CCollapse>
                    </CCard>
                  </div>
                </draggable>
                <!--Fin Dragable reservado -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-2 mb-2">
            <div class="bg-card-curso p-4 rounded-lg shadow mb-4">
              <h3 class="text-lg font-semibold mb-2 text-title">En curso</h3>
              <input type="text" placeholder="Buscar" class="form-control mb-4" />
              <div id="content-curso" class="px-2">
                <!-- Inicio Dragable en curso -->
                <draggable :disabled="isMobile" :group="{ name: 'states' }" class="list-group" @end="onDragEncurso"
                  id="encurso">
                  <div v-for="(item, index) in listencurso" :key="index" class="text-dark">
                    <CCard>
                      <CCardHeader>
                        <CRow class="mb-2">
                          <CCol class="col-9">
                            <strong>Encargado:</strong>
                            <span v-for="(barber, index) in item.barber_detail" :key="index">
                              {{
                                barber.barber
                                  ? barber.barber.name +
                                  " " +
                                  barber.barber.last_name
                                  : "No existe Personal"
                              }}{{
                                item.barber_detail.length - 1 == index
                                  ? ""
                                  : ","
                              }}
                            </span>
                          </CCol>
                          <CCol class="col-3 text-right">
                            <CButton v-if="
                              item.payment == 0 ||
                              item.payment == 1 ||
                              (item.sale.voucher &&
                                item.sale.voucher[0] &&
                                item.sale.voucher[0].document_type_id == 3)
                            " class="card-header-action btn-close bg-danger text-white mr-2"
                              @click="mtdEliminar(item)">
                              <i class="fas fa-trash"></i>
                            </CButton>
                          </CCol>
                        </CRow>
                        <CRow class="mb-2">
                          <CCol class="col-12">
                            <strong>Cliente: </strong>{{ item.name_client }}
                          </CCol>
                        </CRow>
                        <CRow class="mb-2">
                          <CCol class="col-6">
                            Hora: {{ formatTime(item.hour) }}
                          </CCol>
                          <CCol class="col-6 text-right">
                            {{ formatDate(item.date) }}
                          </CCol>
                        </CRow>
                        <div class="card-header-actions">
                          <CButton color="primary" class="card-header-action bg-primary text-white mr-2"
                            v-c-tooltip.hover="{
                              content: `Descripción`,
                            }" @click="mtdAddDescription(item)">
                            <!-- +Descripción -->
                            <i class="fas fa-list"></i>
                          </CButton>
                          <CButton class="card-header-action btn-minimize bg-info text-white mr-2"
                            @click="mtdSelectCardReserva(item.id)">
                            <div v-if="!isMobile">
                              <i v-if="isCollapsed == item.id" class="fas fa-chevron-up"></i>
                              <i v-else class="fas fa-chevron-down"></i>
                            </div>
                          </CButton>
                          <CButton v-if="item.client?.phone != null"
                            class="card-header-action btn-close bg-success text-white mr-2"
                            @click="mtdViewSendWsp(item)">
                            <i class="fab fa-whatsapp"></i>
                          </CButton>
                          <CButton v-if="
                            getPayment(item.payment) == 'Sin Pagar' ||
                            getPayment(item.payment) == 'Parcialmente Pagado'
                          " class="card-header-action btn-close bg-success text-white mr-2"
                            @click="mtdUpdateQuote(item.id, item.state)">
                            <i class="fas fa-edit"></i>
                          </CButton>
                          <CButton class="card-header-action bg-dark text-white" @click="updateItemState(item.id, 3)">
                            <i class="fas fa-hand-point-right"></i>
                          </CButton>
                        </div>
                      </CCardHeader>
                      <CCollapse :show="isCollapsed == item.id || isMobile" :duration="400">
                        <CCardBody>
                          <div>
                            <strong>Servicios:</strong>
                            <ul v-for="(service, index) in item.detail" :key="index">
                              <li>
                                {{ service.name_service }} - S/
                                {{ service.price }} ({{ service.quantity }})
                              </li>
                            </ul>
                          </div>
                          <div v-if="
                            item.detail_product && item.detail_product.length
                          ">
                            <strong>Productos:</strong> <br />
                            <ul v-for="(prod, index) in item.detail_product" :key="index">
                              <li>
                                {{ prod.name }} - S/ {{ prod.price }} - und. ({{
                                  prod.quantity
                                }})
                              </li>
                            </ul>
                          </div>
                          <div>
                            <strong>Total:<i> {{ item.total }}</i>
                            </strong>
                          </div>

                          <div class="mt-2 d-flex flex-wrap">
                            <CButton :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdPaymentBooking(item)" :disabled="getPayment(item.payment) == 'Pagado'">
                              {{ getPayment(item.payment) }}
                            </CButton>
                            <!-- <CButton v-if="!item.detail_product" :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1 '
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdAddCourtesy(item.id, product)"
                              :disabled="getPayment(item.payment) == 'Pagado'">
                              Productos
                            </CButton>
                            <CButton v-else :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdEditCourtesy(item, product)"
                              :disabled="getPayment(item.payment) == 'Pagado'">
                              Productos
                            </CButton> -->
                            <CButton v-if="getPayment(item.payment) == 'Pagado'" :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm my-1'
                                : 'btn btn-danger btn-sm mr-1 my-1',
                            ]" @click="mtd_ticket(item)">
                              <i class="fas fa-file-pdf"></i>
                            </CButton>
                            <CButton class="btn-sm my-1 mr-1" color="primary" v-c-tooltip.hover="{
                              content: `Servicios anteriores`,
                            }" @click="mtdViewServices(item)">
                              <i class="fas fa-cut"></i>
                            </CButton>
                          </div>
                          <!-- <div class="mt-2 d-flex">
                            <button v-if="item.courtesy === 0" class="btn btn-info btn-sm"
                              @click="mtdAddCourtesy(item.id, cortesy)">
                              Agregar Cortesía
                            </button>
                            <button v-else class="btn btn-warning text-white btn-sm"
                              @click="mtdEditCourtesy(item, cortesy)">
                              Editar Cortesía
                            </button>
                          </div> -->
                        </CCardBody>
                      </CCollapse>
                    </CCard>
                  </div>
                </draggable>
                <!-- Fin Dragable en curso -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-2 mb-2">
            <div class="bg-card-terminado p-4 rounded-lg shadow mb-4">
              <h3 class="text-lg font-semibold mb-2 text-title">Terminado</h3>
              <input type="text" placeholder="Buscar" class="form-control mb-4" />
              <div id="content-terminado" class="px-2">
                <!-- Inicio Dragable terminado -->
                <draggable :disabled="isMobile" :group="{ name: 'states', pull: false }" class="list-group"
                  @end="onDragTerminado" id="terminado">
                  <div v-for="(item, index) in listterminado" :key="index" class="text-dark">
                    <CCard>
                      <CCardHeader>
                        <CRow class="mb-2">
                          <CCol class="col-9">
                            <strong>Encargado:</strong>
                            <span v-for="(barber, index) in item.barber_detail" :key="index">
                              {{
                                barber.barber
                                  ? barber.barber.name +
                                  " " +
                                  barber.barber.last_name
                                  : "No existe Personal"
                              }}{{
                                item.barber_detail.length - 1 == index
                                  ? ""
                                  : ","
                              }}
                            </span>
                          </CCol>
                          <!-- <CCol class="col-3 text-right">
                            <CButton
                              v-if="
                                item.payment == 0 ||
                                item.payment == 1 ||
                                (item.sale.voucher &&
                                  item.sale.voucher[0] &&
                                  item.sale.voucher[0].document_type_id == 3)
                              "
                              class="card-header-action btn-close bg-danger text-white mr-2"
                              @click="mtdEliminar(item)"
                            >
                              <i class="fas fa-trash"></i>
                            </CButton>
                          </CCol> -->
                        </CRow>
                        <CRow class="mb-2">
                          <CCol class="col-12">
                            <strong>Cliente: </strong>{{ item.name_client }}
                          </CCol>
                        </CRow>
                        <CRow class="mb-2">
                          <CCol class="col-12">
                            <b>Fec. y hora:</b> {{ formatDate(item.date) }}
                            {{ formatTime(item.hour) }}
                          </CCol>
                        </CRow>
                        <div class="card-header-actions">
                          <CButton class="card-header-action btn-minimize text-info mr-2"
                            @click="mtdSelectCardReserva(item.id)">
                            <div v-if="!isMobile">
                              <i v-if="isCollapsed == item.id" class="fas fa-chevron-up"></i>
                              <i v-else class="fas fa-chevron-down"></i>
                            </div>
                          </CButton>
                          <CButton v-if="$store.getters.get_rol.name == 'ADMINISTRADOR' ||
                            $store.getters.get_rol.name == 'RECEPCIÓN'"
                            class="card-header-action btn-close bg-success text-white mr-2"
                            @click="mtdUpdateQuote(item.id, item.state)">
                            <i class="fas fa-edit"></i>
                          </CButton>
                        </div>
                      </CCardHeader>
                      <CCollapse :show="isCollapsed == item.id || isMobile" :duration="400">
                        <CCardBody>
                          <div>
                            <strong>Servicios:</strong>
                            <ul v-for="(service, index) in item.detail" :key="index">
                              <li>
                                {{ service.name_service }} - S/
                                {{ service.price }} ({{ service.quantity }})
                              </li>
                            </ul>
                          </div>
                          <div v-if="
                            item.detail_product && item.detail_product.length
                          ">
                            <strong>Productos:</strong>
                            <ul v-for="(prod, index) in item.detail_product" :key="index">
                              <li>
                                {{ prod.name }} - S/ {{ prod.price }} - und.
                                {{ prod.quantity }}
                              </li>
                            </ul>
                          </div>
                          <div>
                            <strong>Total:<i> {{ item.total }}</i></strong>
                          </div>
                          <div class="mt-2 d-flex flex-wrap">
                            <CButton :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdPaymentBooking(item)" :disabled="getPayment(item.payment) == 'Pagado'">
                              {{ getPayment(item.payment) }}
                            </CButton>
                            <CButton v-if="
                              item.detail_service != null &&
                              item.barber_detail.length === 0
                            " @click="mtdAddDescriptionAnterior(item)"
                              class="btn btn-warning btn-sm mr-1 my-1 text-white" v-c-tooltip.hover="{
                                content: `Descripción`,
                              }">
                              <!-- +Descripción -->
                              <i class="fas fa-list"></i>
                            </CButton>
                            <CButton v-if="
                              item.detail_service == null &&
                              item.barber_detail.length != 0
                            " @click="mtdAddDescription(item)" class="btn btn-warning btn-sm mr-1 my-1 text-white"
                              v-c-tooltip.hover="{
                                content: `Descripción`,
                              }">
                              <!-- +Descripción -->
                              <i class="fas fa-list"></i>
                            </CButton>
                            <CButton v-if="getPayment(item.payment) == 'Pagado'" :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-danger btn-sm mr-1 my-1',
                            ]" @click="mtd_ticket(item)">
                              <i class="fas fa-file-pdf"></i>
                            </CButton>

                            <!-- <button v-if="!item.detail_product" :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdAddCourtesy(item.id, product)"
                              :disabled="getPayment(item.payment) == 'Pagado'">
                              Productos
                            </button>
                            <button v-else :class="[
                              getPayment(item.payment) != 'Pagado'
                                ? 'btn btn-info btn-sm mr-1 my-1'
                                : 'btn btn-success btn-sm mr-1 my-1',
                            ]" @click="mtdEditCourtesy(item, product)" :disabled="getPayment(item.payment) == 'Pagado'">
                              Productos
                            </button> -->
                            <CButton class="btn-sm my-1 mr-1" color="primary" v-c-tooltip.hover="{
                              content: `Servicios anteriores`,
                            }" @click="mtdViewServices(item)">
                              <i class="fas fa-cut"></i>
                            </CButton>
                          </div>
                        </CCardBody>
                      </CCollapse>
                    </CCard>
                  </div>
                </draggable>
                <!-- Fin Dragable terminado -->
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
    <cModalUpdateQuoteVue :title="modalUpdateQuote.title" :boo_modal="modalUpdateQuote.modal_form"
      :id="modalUpdateQuote.id_reserva" @closeModalUpdateQuote="closeModalUpdateQuote"
      :state="modalUpdateQuote.state" />
    <cModalPaymentVue :title="modalPaymentBooking.title" :boo_modal="modalPaymentBooking.modal_form"
      :id="modalPaymentBooking.id_reserva" :total_pay="modalPaymentBooking.total_pay"
      :id_sale="modalPaymentBooking.id_sale" :item="modalPaymentBooking.item"
      :id_cliente="modalPaymentBooking.id_cliente" :client_document="modalPaymentBooking.client_document"
      :client_name="modalPaymentBooking.client_name" :detail_product="modalPaymentBooking.detail_product"
      @closeModalPaymentBooking="closeModalPaymentBooking" />
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Reserva'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
    <cModalCourtesy :id="modalCourtesy.id" :title="modalCourtesy.title" :type="modalCourtesy.type"
      :boo_modal="modalCourtesy.modal_form" @closeModalCourtesy="closeModalCourtesy" :dataProducts="dataProducts" />
    <cModalPaymentMethodVue :title="modalPaymentMethod.title" :boo_modal="modalPaymentMethod.modal_form"
      :item="modalPaymentMethod.item" :advance_payment="modalPaymentMethod.advance_payment"
      :disabled_f="modalPaymentMethod.disabled_f" @closeModalPaymentMethod="closeModalPaymentMethod"
      @submitPaymentData="handlePaymentData" />
    <CModalDescription :id_reserva="modalDescription.id_reserva" :title="modalDescription.title"
      :boo_modal="modalDescription.modal_form" :item="modalDescription.item"
      @closeModalDescription="closeModalDescription" @mtdAddDescription="mtdAddDescription" />
    <CModalDescriptionAnterior :id_reserva="modalDescriptionAnterior.id_reserva" :title="modalDescriptionAnterior.title"
      :boo_modal="modalDescriptionAnterior.modal_form" :item="modalDescriptionAnterior.item"
      @closeModalDescriptionAnterior="closeModalDescriptionAnterior" @mtdAddDescription="mtdAddDescriptionAnterior" />
    <cModalServicesAntVue :title="modalServiceAnt.title" :boo_modal="modalServiceAnt.modal_form"
      :services="modalServiceAnt.services" @closeModalServiceAnt="closeModalServiceAnt" />
    <cModalEliminarVue :title="modalEliminar.title" :boo_modal="modalEliminar.modal_form"
      :id_reserva="modalEliminar.id_reserva" :state_payment="modalEliminar.state_payment"
      @closeModalEliminar="closeModalEliminar" />
    <cModalSendWspVue :title="modalSentWsp.title" :boo_modal="modalSentWsp.modal_form" :client="modalSentWsp.client"
      @closeModalSendWsp="closeModalSendWsp" />
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";
import moment from "moment";
import { bus } from "../../../main";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import cModalPaymentVue from "../modals/cModalPayment.vue";
import cModalUpdateQuoteVue from "./modals/cModalUpdateQuote.vue";
import cModalCourtesy from "../modals/cModalCourtesy.vue";
import cModalPaymentMethodVue from "../modals/cModalPaymentMethod.vue";
import CModalDescription from "../modals/cModalDescription.vue";
import CModalDescriptionAnterior from "../modals/cModalDescriptionAnterior.vue";
import cModalServicesAntVue from "../modals/cModalServicesAnt.vue";
import cModalEliminarVue from "../modals/cModalEliminar.vue";
import cModalSendWspVue from "../modals/cModalSendWsp.vue";
import { CButton } from "@coreui/vue-pro";

export default {
  components: {
    draggable,
    cModalDelete,
    cModalPaymentVue,
    cModalUpdateQuoteVue,
    cModalCourtesy,
    cModalPaymentMethodVue,
    CModalDescription,
    CModalDescriptionAnterior,
    cModalServicesAntVue,
    cModalEliminarVue,
    cModalSendWspVue,
  },
  data() {
    return {
      dataProducts: [],
      prefix: "cita",
      cortesy: "cortesy",
      product: "product",
      listreservado: [],
      listencurso: [],
      listterminado: [],
      modalSentWsp: {
        title: "MENSAJE PARA ENVIAR",
        modal_form: false,
        client: {},
        // services: [],
      },
      modalServiceAnt: {
        title: "VER SERVICIOS ANTERIORES",
        modal_form: false,
        services: [],
      },
      modalEliminar: {
        title: "ELIMINAR",
        modal_form: false,
        id_reserva: 0,
        state_payment: 10,
      },
      modalPaymentBooking: {
        title: "PAGAR RESERVA",
        modal_form: false,
        id_reserva: 0,
        total_pay: "",
        id_sale: 0,
        // id_barber: 0,
        id_cliente: 0,
        client_name: "",
        client_document: "",
        detail_product: [],
        item: {},
      },
      modalPaymentMethod: {
        title: "PAGAR RESERVA",
        modal_form: false,
        item: {},
        advance_payment: 0,
        disabled_f: true,
      },
      modalDescription: {
        title: "AGREGAR DESCRIPCION",
        modal_form: false,
        item: {},
        id_reserva: 0,
      },
      modalDescriptionAnterior: {
        title: "AGREGAR DESCRIPCION Anterior",
        modal_form: false,
        item: {},
        id_reserva: 0,
      },
      modalCourtesy: {
        title: "",
        modal_form: false,
        item: [],
        id: 0,
        type: "",
      },
      modalEditCourtesy: {
        title: "EDITAR CORTESÍA",
        modal_form: false,
        item: [],
        id: 0,
      },
      modalUpdateQuote: {
        title: "EDITAR RESERVA",
        item: [],
        modal_form: false,
        pos: null,
        id_reserva: 0,
        state: null,
      },

      modal_delete: {
        boo: false,
        item: [],
      },
      quote: {
        id: "",
        hour: "",
        name_client: "",
        services: [],
        barbers: [],
        total: 0,
        state: "",
      },
      filter: {
        init: null,
        end: null,
      },
      isMobile: false,
      isCollapsed: null,
      verificBead: false,
    };
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.applyDateFilter();
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  methods: {
    ...mapActions(["get", "post"]),
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.checkScreenSize);
    },
    mtdBack: function () {
      this.$emit("setView", "home");
    },
    mtd_delete(item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete() {
      this.modal_delete.boo = false;
    },
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    validateDays() {
      if (this.filter.init > this.filter.end) {
        Swal.fire({
          title: "La fecha de inicio no puede ser mayor a la fecha final",
          icon: "warning",
        });
        this.filter.init = this.filter.end;
      }
    },
    applyDateFilter() {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/dragable",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
          user_id: this.$store.getters.get__user_id,
          rol_id: this.$store.getters.get_rol.id,
        },
      })
        .then((response) => {
          this.data = response.data.data;
          this.listreservado = [];
          this.listencurso = [];
          this.listterminado = [];
          this.categorizeData();
          this.showBead();
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    onDragReservado(event) {
      const draggedIndex = event.oldIndex;
      const draggedItem = this.listreservado[draggedIndex];
      const idAsign = draggedItem.id;
      let status;
      if (event.to.id === "reservado") {
        status = 1;
      } else if (event.to.id === "encurso") {
        status = 2;
      } else if (event.to.id === "terminado") {
        status = 3;
      }
      if (status != 1) {
        this.updateItemState(idAsign, status);
      }
    },
    onDragEncurso(event) {
      const draggedIndex = event.oldIndex;
      const draggedItem = this.listencurso[draggedIndex];
      const idAsign = draggedItem.id;
      let status;
      if (event.to.id === "reservado") {
        status = 1;
      } else if (event.to.id === "encurso") {
        status = 2;
      } else if (event.to.id === "terminado") {
        status = 3;
      }
      if (status != 2) {
        this.updateItemState(idAsign, status);
      }
    },
    onDragTerminado(event) {
      const draggedIndex = event.oldIndex;
      const draggedItem = this.listterminado[draggedIndex];
      const idAsign = draggedItem.id;
      let status;
      if (event.to.id === "reservado") {
        status = 1;
      } else if (event.to.id === "encurso") {
        status = 2;
      } else if (event.to.id === "terminado") {
        status = 3;
      }
      if (status != 3) {
        this.updateItemState(idAsign, status);
      }
    },
    categorizeData() {
      if (this.data.length > 0) {
        this.data.forEach((item) => {
          if (item.state == 1) {
            item.detail_product = JSON.parse(item.detail_product);
            this.listreservado.push(item);
          } else if (item.state == 2) {
            item.detail_product = JSON.parse(item.detail_product);
            this.listencurso.push(item);
          } else if (item.state == 3) {
            item.detail_product = JSON.parse(item.detail_product);
            this.listterminado.push(item);
          }
        });
      }
    },
    mtdAddCourtesy(item, type) {
      this.modalCourtesy = {
        title: type == "product" ? "AGREGAR PRODUCTO" : "AGREGAR CORTESÍA",
        modal_form: true,
        id: item,
        type: type,
      };
    },
    mtdEditCourtesy(payload, type) {
      this.modalCourtesy = {
        title: type == "product" ? "EDITAR PRODUCTO" : "EDITAR CORTESÍA",
        modal_form: true,
        id: payload.id,
        type: type,
      };
      this.dataProducts =
        type == "product"
          ? payload.detail_product
          : JSON.parse(payload.detail_courtesy);
    },
    mtdUpdateQuote: function (id, state) {
      this.modalUpdateQuote = {
        title: "EDITAR RESERVA",
        modal_form: true,
        id_reserva: id,
        state: state,
      };
    },
    closeModalUpdateQuote: function (refresh) {
      this.modalUpdateQuote = {
        item: [],
        modal_form: false,
        pos: null,
        state: null,
      };
      if (refresh) {
        this.applyDateFilter();
      }
    },
    closeModalCourtesy(refresh) {
      this.modalCourtesy = {
        modal_form: false,
        pos: null,
      };
      if (refresh) {
        this.applyDateFilter();
      }
    },
    mtdPaymentBooking: function (item) {
      if (this.verificBead == true) {
        this.modalPaymentBooking = {
          title: "PAGAR RESERVA",
          modal_form: true,
          id_reserva: item.id,
          total_pay: item.total,
          id_sale: item.sale_id,
          // id_barber: item.barber_id,
          id_cliente: item.client.id,
          client_name: item.client.name,
          client_document: item.client.document,
          detail_product: item.detail_product,
          item: item,
        };
      } else {
        Swal.fire({
          title: "NO HAY CAJA APERTURADA",
          text: "Aperture una caja para poder pagar",
          icon: "warning",
        });
      }
    },
    mtdAddDescription: function (item) {
      this.modalDescription = {
        title: "AGREGAR DESCRIPCIÓN",
        id_reserva: item.id,
        modal_form: true,
        item: item,
      };
    },
    mtdAddDescriptionAnterior: function (item) {
      this.modalDescriptionAnterior = {
        title: "AGREGAR DESCRIPCIÓN ANTERIOR",
        id_reserva: item.id,
        modal_form: true,
        item: item,
      };
    },
    closeModalPaymentBooking: function (refresh) {
      this.modalPaymentBooking = {
        modal_form: false,
      };
      if (refresh) {
        this.applyDateFilter();
      }
    },
    formatDate: function (date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    updateItemState(idAsign, status) {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const time = `${hours}:${minutes}:${seconds}`;

      this.post({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/updateItemState",
        token: this.$store.getters.get__token,
        params: {
          idAsign: idAsign,
          time: time,
          status: status,
        },
      })
        .then((response) => {
          if (response.data.state == 0) {
            this.listreservado = [];
            this.listencurso = [];
            this.listterminado = [];
            this.applyDateFilter();
          } else if(response.data.state == 1){
            Swal.fire({
              title: response.message,
              icon: "warning",
            });
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    formatTime(time) {
      const [hour, minute] = time.split(":");
      const formattedHour = hour % 12 || 12;
      const ampm = hour < 12 ? "AM" : "PM";
      return `${formattedHour}:${minute} ${ampm}`;
    },
    mtdSelectCardReserva: function (id) {
      if (id == this.isCollapsed) {
        this.isCollapsed = null;
      } else {
        this.isCollapsed = id;
      }
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
          }
        })
        .catch((errors) => { });
    },
    getPayment(payment) {
      switch (String(payment)) {
        case "0":
          return "Sin Pagar";
        case "1":
          return "Parcialmente Pagado";
        case "2":
          return "Pagado";
        default:
          return "Pendiente";
      }
    },
    mtd_commit() {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.id,
          campu_id: this.$store.getters.get_campu.id,
          user_id: this.$store.getters.get__user_id,
        },
      })
        .then((response) => {
          this.data = this.data.filter(
            (element) => element.id != response.data.id
          );
          this.listreservado = [];
          this.listencurso = [];
          this.listterminado = [];
          this.applyDateFilter();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            icon: "success",
            title: "ELIMINADO CORRECTAMENTE",
          });
        })
        .catch((errors) => {
          Swal.fire({
            icon: "danger",
            title: "ERROR AL ELIMINAR",
          });
        });
    },
    mtdPaymentMethod: function (item) {
      this.modalPaymentMethod = {
        title: "Adelanto de Pago",
        modal_form: true,
        item: item,
        advance_payment: Number(item.advance_payment),
        disabled_f: true,
      };
    },
    closeModalDescription(refresh) {
      this.modalDescription = {
        modal_form: false,
      };
      if (refresh) {
        this.applyDateFilter();
      }
    },
    closeModalDescriptionAnterior() {
      this.modalDescriptionAnterior = {
        modal_form: false,
      };
    },
    closeModalPaymentMethod: function () {
      this.modalPaymentMethod = {
        modal_form: false,
      };
    },
    handlePaymentData({ filledPayments, fech_advance, quote }) {
      this.mtdStoreAdvance(filledPayments, fech_advance, quote);
    },
    mtdStoreAdvance: function (filledPayments, fech_advance, quote) {
      this.post({
        url:
          this.$store.getters.get__url +
          "/cita/advance_payment/" +
          this.$store.getters.get_company.id +
          "/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get__user_id,
        token: this.$store.getters.get__token,
        params: {
          payment_methods: filledPayments,
          fech_advance: fech_advance,
          quote: quote,
        },
      })
        .then((response) => {
          if (response.data.state == 0 || response.data.state == 1) {
            Swal.fire({
              title: "Pago Adelantado correctamente",
              icon: "success",
            });
            this.applyDateFilter();
            if (response.data.state == 1) {
              this.openTicket(response.data.voucher, response.data.quote);
            }
          }
        })
        .catch((errors) => { });
    },
    openTicket(id, quote) {
      window.open(
        this.$store.getters.get__url +
        "/cita/ticket/" +
        id +
        "/" +
        quote +
        "/" +
        this.$store.getters.get__user_id,
        "_blank"
      );
    },
    mtd_ticket(item) {
      if (item?.sale?.voucher?.[0]?.id && item?.sale?.voucher?.[0]?.detail) {
        const voucher = item.sale.voucher[0].id;
        const quote = item.sale.voucher[0].detail;
        const document_name = item.sale.voucher[0].document_type.name;
        if (document_name == "NOTA DE VENTA") {
          window.open(
            this.$store.getters.get__url +
            "/cita/ticket/" +
            voucher +
            "/" +
            quote +
            "/" +
            this.$store.getters.get__user_id,
            "_blank"
          );
        } else {
          const sunatData = JSON.parse(item.sale.voucher[0].sunat);
          const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
          window.open(ticketUrl, "_blank");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Ticket",
          text: "Está cita todavía no tiene documento",
        });
      }
    },
    closeModalServiceAnt: function () {
      this.modalServiceAnt.modal_form = false;
    },
    mtdViewServices: function (item) {
      // console.log(item.client.document);
      if (item.client.name.length > 0) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/cita/getservices/" +
            this.$store.getters.get_company.id +
            "/" +
            item.client.document,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.length == 0) {
            Swal.fire({
              title: "No tiene servicios anteriores!",
              icon: "warning",
            });
          } else {
            this.modalServiceAnt.modal_form = true;
            this.modalServiceAnt.services = response.data;
          }
        });
      } else {
        Swal.fire({
          title: "Busque un cliente",
          icon: "warning",
        });
      }
    },
    closeModalEliminar: function (refresh) {
      this.modalEliminar.modal_form = false;
      if (refresh) {
        this.applyDateFilter();
      }
    },
    mtdEliminar: function (item) {
      if (item.client.name.length > 0) {
        this.modalEliminar.modal_form = true;
        this.modalEliminar.id_reserva = item.id;
        this.modalEliminar.state_payment = item.payment;
      }
    },
    mtdViewSendWsp: function (item) {
      if (item.client?.phone != null) {
        this.modalSentWsp.modal_form = true;
        this.modalSentWsp.client = item.client;
      } else {
        Swal.fire({
          title: "No tiene telefono registrado",
          icon: "warning",
        });
      }
    },
    closeModalSendWsp: function () {
      this.modalSentWsp.modal_form = false;
    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #00003a;
}

.color-white {
  color: white;
}

.text-title {
  color: #00003a;
}

.bg-card-reservado {
  background-color: #fff043;
}

.bg-card-curso {
  background-color: #749dff;
}

.bg-card-terminado {
  background-color: #b1b1af;
}

.lista {
  cursor: pointer;
}

.sizeIcon {
  font-size: 18px;
}

@media (min-width: 1024px) and (max-height: 768px) {

  /* Resolusion Desktop 1024 x 768 */
  #content-reservado,
  #content-curso,
  #content-terminado {
    height: 450px !important;
    min-height: 280px !important;
    overflow-y: auto;
  }
}

@media (min-width: 1280px) and (max-height: 900px) {

  /* Resolusion Desktop 1280 x 900 */
  #content-reservado,
  #content-curso,
  #content-terminado {
    height: 440px !important;
    min-height: 350px !important;
    overflow-y: auto;
  }
}

@media (min-width: 1440px) and (max-height: 1024px) {

  /* Resolusion Desktop 1440 x 1024 */
  #content-reservado,
  #content-curso,
  #content-terminado {
    height: 540px !important;
    min-height: 450px !important;
    overflow-y: auto;
  }
}

@media (min-width: 1920px) and (min-height: 1080px) {

  /* Resolusion Desktop 1920 x 1080 */
  #content-reservado,
  #content-curso,
  #content-terminado {
    height: 560px !important;
    min-height: 460px !important;
    overflow-y: auto;
  }
}

#content-reservado::-webkit-scrollbar,
#content-curso::-webkit-scrollbar,
#content-terminado::-webkit-scrollbar {
  -webkit-appearance: none;
}

#content-reservado::-webkit-scrollbar:vertical,
#content-curso::-webkit-scrollbar:vertical,
#content-terminado::-webkit-scrollbar:vertical {
  width: 10px;
}

#content-reservado::-webkit-scrollbar-button:increment,
#content-reservado::-webkit-scrollbar-button,
#content-curso::-webkit-scrollbar-button:increment,
#content-curso::-webkit-scrollbar-button,
#content-terminado::-webkit-scrollbar-button:increment,
#content-terminado::-webkit-scrollbar-button {
  display: none;
}

#content-reservado::-webkit-scrollbar:horizontal,
#content-curso::-webkit-scrollbar:horizontal,
#content-terminado::-webkit-scrollbar:horizontal {
  height: 10px;
}

#content-reservado::-webkit-scrollbar-thumb,
#content-curso::-webkit-scrollbar-thumb,
#content-terminado::-webkit-scrollbar-thumb {
  background-color: #797979;
  border-radius: 20px;
  border: 2px solid #f1f2f3;
}

#content-reservado::-webkit-scrollbar-track,
#content-curso::-webkit-scrollbar-track,
#content-terminado::-webkit-scrollbar-track {
  border-radius: 10px;
}

@media (max-width: 768px) {
  .collapse.show {
    display: block !important;
  }
}

@media only screen and (max-width: 1200px) {}
</style>
